import { ISdk } from "../types"
import getCSSVariables, { getTileSizeByWidget, trimHashValuesFromObject } from "./css-variables"

// Mock sdk object globally
const sdk = {
  getStyleConfig: jest.fn(),
  getInlineTileConfig: jest.fn(),
  getExpandedTileConfig: jest.fn()
} as unknown as ISdk

// @ts-expect-error global properties are not typed
global.sdk = sdk

describe("Widget Functions", () => {
  // Tests for getTileSizeByWidget
  describe("getTileSizeByWidget", () => {
    it("should return medium size when inline_tile_size is not defined", () => {
      // @ts-expect-error Mocking the sdk.getStyleConfig method
      sdk.getStyleConfig.mockReturnValue({})

      const result = getTileSizeByWidget(sdk)
      expect(result).toEqual({ "--tile-size": "265.5px", "--tile-size-unitless": "265.5" })
    })

    it("should return correct tile size based on inline_tile_size", () => {
      // @ts-expect-error Mocking the sdk.getStyleConfig method
      sdk.getStyleConfig.mockReturnValue({ inline_tile_size: "small" })
      expect(getTileSizeByWidget(sdk)).toEqual({ "--tile-size": "173px", "--tile-size-unitless": "173" })

      // @ts-expect-error Mocking the sdk.getStyleConfig method
      sdk.getStyleConfig.mockReturnValue({ inline_tile_size: "medium" })
      expect(getTileSizeByWidget(sdk)).toEqual({ "--tile-size": "265.5px", "--tile-size-unitless": "265.5" })

      // @ts-expect-error Mocking the sdk.getStyleConfig method
      sdk.getStyleConfig.mockReturnValue({ inline_tile_size: "large" })
      expect(getTileSizeByWidget(sdk)).toEqual({ "--tile-size": "400px", "--tile-size-unitless": "400" })
    })
  })
  // Tests for getCSSVariables
  describe("getCSSVariables", () => {
    it("should return the correct CSS variables", () => {
      // @ts-expect-error Mocking the sdk.getStyleConfig method
      sdk.getStyleConfig.mockReturnValue({
        widget_background: "ffffff",
        text_tile_background: "000000",
        text_tile_link_color: "ff0000",
        text_tile_user_name_font_color: "0000ff",
        text_tile_user_handle_font_color: "00ff00",
        shopspot_btn_background: "ff00ff",
        shopspot_btn_font_color: "00ffff",
        cta_btn_background: "000000",
        cta_btn_font_color: "ffffff",
        cta_btn_font_size: "10",
        margin: 10,
        text_tile_font_size: 16,
        text_caption_paragraph_font_size: 12,
        text_tile_user_name_font_size: 16,
        text_tile_user_handle_font_size: null,
        shopspot_icon: null,
        expanded_tile_border_radius: 5,
        tile_tag_background: "D6D4D5"
      })

      // @ts-expect-error Mocking the sdk.getInlineTileConfig method
      sdk.getInlineTileConfig.mockReturnValue({
        show_timestamp: true,
        show_caption: false
      })

      // @ts-expect-error Mocking the sdk.getExpandedTileConfig method
      sdk.getExpandedTileConfig.mockReturnValue({
        show_tags: false
      })

      // Check if the generated CSS variables match the snapshot
      const cssVariables = getCSSVariables(sdk)
      expect(cssVariables).toMatchSnapshot()
    })

    it("should return correct sizes with custom tile size settings", () => {
      // @ts-expect-error Mocking the sdk.getStyleConfig method
      sdk.getStyleConfig.mockReturnValue({})
      const tileSizeSettings = {
        tileSizeSettings: {
          small: "100px",
          medium: "200px",
          large: "300px"
        }
      }

      const result = getCSSVariables(sdk, tileSizeSettings)
      expect(result).toContain("--tile-size: 200px;")
    })

    it("should replace hashes with nothing in the returned object", () => {
      const value = trimHashValuesFromObject({
        widget_background: "#ffffff",
        text_tile_background: "#000000",
        text_tile_font_color: "#333333",
        text_tile_link_color: "#ff0000",
        text_tile_user_name_font_color: "#0000ff",
        text_tile_user_handle_font_color: "#00ff00",
        shopspot_btn_background: "#ff00ff",
        shopspot_btn_font_color: "#00ffff",
        margin: "10",
        text_tile_font_size: "16",
        text_caption_paragraph_font_size: "12",
        text_tile_user_name_font_size: "16",
        tile_tag_background: "#D6D4D5",
        auto_refresh: "",
        click_through_url: "",
        enable_custom_tiles_per_page: false,
        load_more_type: "scroll",
        name: "",
        plugin_instance_id: "",
        polling_frequency: "",
        rows_per_page: "",
        shopspot_btn_font_size: "",
        shopspot_icon: "",
        style: "",
        text_tile_user_handle_font_size: "",
        tile_background: "",
        tiles_per_page: "",
        minimal_tiles: "",
        type: "",
        widget_height: "",
        widget_loading_image: "",
        unavailable_products_behaviour: "always_show",
        dynamic_filter: "",
        dynamic_filter_fallback: {
          category: false,
          brand: false,
          custom: 0
        },
        inline_tile_size: "",
        inline_tile_border_radius: "",
        inline_tile_margin: "",
        expanded_tile_border_radius: "",
        map_content_feed_filter_id: "31915",
        map_content_feed_filter_name: "Map Feed",
        displayMode: "map_only",
        isScrollZoomDisabled: false,
        providerApiKey: "",
        providerLayer: "OpenStreetMap.BlackAndWhite",
        connectedContentWidgetId: "",
        defaultBounds: "-33.8336347704208,151.26371383666992,-33.876401620744,151.18646621704102",
        pinColor: "f7584c",
        pinTextColor: "ffffff",
        cta_btn_background: "000000",
        cta_btn_font_color: "ffffff",
        cta_btn_font_size: "10"
      })

      expect(value).toEqual({
        widget_background: "ffffff",
        text_tile_background: "000000",
        text_tile_font_color: "333333",
        text_tile_link_color: "ff0000",
        text_tile_user_name_font_color: "0000ff",
        text_tile_user_handle_font_color: "00ff00",
        shopspot_btn_background: "ff00ff",
        shopspot_btn_font_color: "00ffff",
        margin: "10",
        text_tile_font_size: "16",
        text_caption_paragraph_font_size: "12",
        text_tile_user_name_font_size: "16",
        tile_tag_background: "D6D4D5",
        auto_refresh: "",
        click_through_url: "",
        enable_custom_tiles_per_page: false,
        load_more_type: "scroll",
        name: "",
        plugin_instance_id: "",
        polling_frequency: "",
        rows_per_page: "",
        shopspot_btn_font_size: "",
        shopspot_icon: "",
        style: "",
        text_tile_user_handle_font_size: "",
        tile_background: "",
        tiles_per_page: "",
        minimal_tiles: "",
        type: "",
        widget_height: "",
        widget_loading_image: "",
        unavailable_products_behaviour: "always_show",
        dynamic_filter: "",
        dynamic_filter_fallback: {
          category: false,
          brand: false,
          custom: 0
        },
        inline_tile_size: "",
        inline_tile_border_radius: "",
        inline_tile_margin: "",
        expanded_tile_border_radius: "",
        map_content_feed_filter_id: "31915",
        map_content_feed_filter_name: "Map Feed",
        displayMode: "map_only",
        isScrollZoomDisabled: false,
        providerApiKey: "",
        providerLayer: "OpenStreetMap.BlackAndWhite",
        connectedContentWidgetId: "",
        defaultBounds: "-33.8336347704208,151.26371383666992,-33.876401620744,151.18646621704102",
        pinColor: "f7584c",
        pinTextColor: "ffffff",
        cta_btn_background: "000000",
        cta_btn_font_color: "ffffff",
        cta_btn_font_size: "10"
      })
    })
  })
})
